import { render, staticRenderFns } from "./MoonPhaseWidget.vue?vue&type=template&id=2993e46c&scoped=true&"
import script from "./MoonPhaseWidget.vue?vue&type=script&lang=js&"
export * from "./MoonPhaseWidget.vue?vue&type=script&lang=js&"
import style0 from "./MoonPhaseWidget.vue?vue&type=style&index=0&id=2993e46c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993e46c",
  null
  
)

export default component.exports